import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const Tooltip = ({ label, children }) => {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);

  // useEffect(() => {
  //   if (!visible) return;

  //   const trigger = triggerRef.current;
  //   const tooltip = tooltipRef.current;
  //   if (!trigger || !tooltip) return;

  //   const rect = trigger.getBoundingClientRect();
  //   const ttRect = tooltip.getBoundingClientRect();

  //   const left =
  //     rect.left + rect.width / 2 - ttRect.width / 2 + window.scrollX;

  //   setPos({
  //     top: rect.bottom + 8 + window.scrollY, // always below
  //     left: Math.max(8, Math.min(left, window.innerWidth - ttRect.width - 8)),
  //   });
  // }, [visible]);
  useEffect(() => {
  if (!visible) return;

  const trigger = triggerRef.current;
  const tooltip = tooltipRef.current;
  if (!trigger || !tooltip) return;

  const rect = trigger.getBoundingClientRect();
  const ttRect = tooltip.getBoundingClientRect();

  const left = rect.left + rect.width / 2 - ttRect.width / 2;

  let top = rect.bottom + 8;

  // flip if no space below
  if (rect.bottom + ttRect.height > window.innerHeight) {
    top = rect.top - ttRect.height - 8;
  }

  setPos({
    top,
    left: Math.max(8, Math.min(left, window.innerWidth - ttRect.width - 8)),
  });
}, [visible]);

  return (
    <>
      <span
        ref={triggerRef}
        className="inline-flex items-center gap-1 cursor-pointer"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </span>

      {visible &&
        createPortal(
          <div
            ref={tooltipRef}
            className="
              fixed z-[99999]
              max-w-[260px]
              rounded-lg
              bg-neutral-100
              px-3 py-2
              text-xs text-black
              leading-relaxed
              whitespace-normal
              shadow-xl
            "
            style={{
              top: pos.top,
              left: pos.left,
            }}
          >
            {label}
          </div>,
          document.body
        )}
    </>
  );
};

export default Tooltip;
